import { ConvertArgs, UnitConverter } from './types';

const ChargeUnits = ['Ah', 'mAh', 'C'] as const;
type TChargeUnit = (typeof ChargeUnits)[number];

type ToBestArgs = Parameters<UnitConverter<TChargeUnit, 'C'>['toBest']>[0];
type ToBaseArgs = Parameters<UnitConverter<TChargeUnit, 'C'>['toBase']>[0];

class ChargeConverter extends UnitConverter<TChargeUnit, 'C'> {
    baseUnit = 'C' as const;
    units = ChargeUnits;

    toBase({ value, from }: ToBaseArgs) {
        return {
            value: value * getMultiplier(from),
            unit: this.baseUnit,
        };
    }

    toBest({ value, from }: ToBestArgs): { value: number; unit: TChargeUnit } {
        const baseValue = this.toBase({ value, from }).value;

        if (Math.abs(baseValue) >= 3600) {
            return { value: baseValue / 3600, unit: 'Ah' };
        }

        return { value: baseValue / 3.6, unit: 'mAh' };
    }

    convert<ToUnit extends TChargeUnit>({ value, from, to }: ConvertArgs<TChargeUnit, ToUnit>) {
        const baseValue = this.toBase({ value, from }).value;
        return {
            value: baseValue / getMultiplier(to),
            unit: to,
        };
    }

    getDisplayUnits(): TChargeUnit[] {
        return ['Ah', 'mAh'];
    }
}

const getMultiplier = (unit: TChargeUnit) => {
    switch (unit) {
        case 'Ah':
            return 3600;
        case 'mAh':
            return 3.6;
        default:
            return 1;
    }
};

export const chargeConverter = new ChargeConverter();
